import { render, staticRenderFns } from "./VideoVue.vue?vue&type=template&id=f89855f2&scoped=true"
import script from "./VideoVue.vue?vue&type=script&lang=js"
export * from "./VideoVue.vue?vue&type=script&lang=js"
import style0 from "./VideoVue.vue?vue&type=style&index=0&id=f89855f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89855f2",
  null
  
)

export default component.exports